import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  message?: string;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ message = 'Carregando...' }) => (
  <div className="w-full flex items-center justify-center py-24">
    <div className="flex items-center gap-2 text-gray-500">
      <Loader2 className="w-6 h-6 animate-spin" />
      <span>{message}</span>
    </div>
  </div>
);
